module.exports = __webpack_public_path__ + "img/ic_close_rounded_nobg.7b98a044.svg";